export default __webpack_public_path__ + "static/media/upload_cloud_error.aa3b6813.svg";